/*
 *
 * EditCompanyPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 02-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as CompanyDataActions from 'Route/CompanyData/modules/CompanyDataActions'
import EditCompanyPopup from './EditCompanyPopup'
import { doShowPopup, doHidePopup } from 'Store/actions/popup'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doShowPopup: (type) => dispatch(doShowPopup(type)),
  doHidePopup: () => dispatch(doHidePopup()),
  ...bindActionCreators(CompanyDataActions, dispatch)
})

const mapStateToProps = (state) => ({
  shopDetail: nullSafe(() => state.CompanyData.shopDetail, {}),
  responseEditAlias: nullSafe(() => state.CompanyData.responseEditAlias, {}),
  isEditShopLoading: nullSafe(() => state.loading.localLoading.edit_shop_alias, false)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(EditCompanyPopup)
